import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { Text } from '@/components/shared/components/Text';

export const businessNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'merchant_id',
    headerName: <Text tId={'BUSINESS_NAME'} />,
    renderCell: (rowData: ReportsListRowProps) => <div style={{ minWidth: '120px' }}>{rowData.row.businessName}</div>,
  };
};
